class InvitationInteractor {
  constructor(dataService, coachGateway) {
    this.dataService = dataService;
    this.coachGateway = coachGateway;
  }

  invitePersonToBeCoached(inviteeEmail) {
    return this.coachGateway.invitePersonToBeCoached(this.dataService.secretKey, inviteeEmail)
      .then(data => {
        this.addInvitationObjectToInteractor(data);
      });
  };

  withSentInvitations() {
    return this.coachGateway.getSentInvitations(this.dataService.secretKey)
      .then(data => {
        this.sentInvitations = data.invitations;
      })
  }

  withReceivedInvitations() {
    return this.coachGateway.getReceivedInvitations(this.dataService.secretKey)
      .then(data => {
        this.receivedInvitations = data.invitations;
      })
  }

  addInvitationObjectToInteractor(invitation) {
    this.sentInvitations.push({
      email: invitation.email,
      created_at: invitation.created_at,
      is_accepted: invitation.is_accepted,
      id: invitation.id
    });
  }

  deleteSentInvitation(invitation) {
    return this.coachGateway.deleteInvitation(this.dataService.secretKey, invitation.id)
      .then(() => this.sentInvitations.splice(this.sentInvitations.indexOf(invitation), 1));
  }

  deleteReceivedInvitation(invitation) {
    return this.coachGateway.deleteInvitation(this.dataService.secretKey, invitation.id)
      .then(() => this.receivedInvitations.splice(this.receivedInvitations.indexOf(invitation), 1));
  }

  acceptInvitation(invitation) {
    return this.coachGateway.acceptInvitation(this.dataService.secretKey, invitation.id)
      .then(() => this.receivedInvitations.splice(this.receivedInvitations.indexOf(invitation), 1));
  }

}

export default InvitationInteractor